var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTable = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF462D",
  fillRule: "evenodd",
  d: "M10.75 7.99C14.817 7.87 18 6.801 18 5.5 18 4.12 14.418 3 10 3S2 4.12 2 5.5c0 1.302 3.183 2.371 7.25 2.49v6.036C7.4 14.158 6 14.768 6 15.5c0 .828 1.79 1.5 4 1.5s4-.672 4-1.5c0-.732-1.4-1.342-3.25-1.474z",
  clipRule: "evenodd"
})));
export default SvgTable;